var Event = require("cocos/framework/components/event")
require("clover/panel/component/common/UIButton")
/**
 * 签到面板中签到条目
 */
MarkedItem = xClass("MarkedItem", Event, function () {
    return cc.CSLoader.createNode("cocos/mark_panel_3_mark_item_marked.csb")
})
MarkedItem.prototype.ctor = function (config) {
    var self = this

    self.config = config
    self.bind(self)
    self.init()
}
MarkedItem.prototype.init = function () { 
    var self = this

    //  天数
    self.txt = self.getChildByName("txt")
    self.txt.setFontWeight("bold")
    self.txt.ignoreContentAdaptWithSize(true)
    self.txt.getVirtualRenderer().setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER)
    self.txt.getVirtualRenderer().setVerticalAlignment(cc.VERTICAL_TEXT_ALIGNMENT_CENTER)
    self.txt.y -= 2
    if (self.config.isToday) {
        self.txt.setString("今天")
    } else {
        self.txt.setString("第" + self.config.day + "天")
    }

    //  已签到动画
    self.mark = self.getChildByName("signet")
    self.markAnim = cc.CSLoader.createTimeline("cocos/mark_panel_3_signet.csb");
    self.mark.runAction(self.markAnim)
    self.markAnim.gotoFrameAndPlay(0, false);
}
module.exports = MarkedItem